var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn btn-default",on:{"click":_vm.navigate}},[_c('i',{staticClass:"fa fa-angle-double-left"}),_vm._v(" Back\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }